import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ForexHub from "@/pages/ForexHub";
import ForexPage from "@/pages/ForexPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/trading-coach" element={<Landing />} />
        <Route path="/six-figure-stock-trading-coach" element={<Landing />} />
        <Route path="/forex" element={<ForexHub />} />
        <Route path="/forex/:slug" element={<ForexPage />} />
        {/* Catch-all: never show a blank/soft-404 — always render the landing page */}
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
